import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MalidCard from './MalidCard';

class NyyrdiView extends Component {
	formatDate(dateStr) {
		let months = [
			'janúar',
			'febrúar',
			'mars',
			'apríl',
			'maí',
			'júní',
			'júlí',
			'ágúst',
			'september',
			'október',
			'nóvember',
			'desember'
		];

		try {
			var d = new Date(dateStr);

			return d.getDate()+'. '+months[d.getMonth()]+' '+d.getFullYear();
		}
		catch(e) {
			console.log(e)
			return '';
		}
	}

	render() {
		return (
			<MalidCard title={window.l('nyyrdi_title')}
			count={this.props.count}
			visible={(this.props.data && this.props.data.length > 0)}
			frontPage={this.props.frontPage}
			aboutText={window.l('nyyrdi_about')}
			database="nyyrdi">
				{
					this.props.data && this.props.data.map(function(item, index) {

						return <React.Fragment key={index}>
							{
								index > 0 && <hr/>
							}
							<p className={'card-text'}>
								<a href={'https://nyyrdi.arnastofnun.is/nyyrdi/'+item.id}><strong>{item.nyyrdi}</strong></a>, {item.ordflokkur}
							</p>
							{
								item.skyring && item.skyring.length > 0 && item.skyring.map((skyring, skIndex) => <React.Fragment key={skIndex}>
									{
										skIndex > 0 && <hr/>
									}
									<p className={'card-text'}>
										{skyring}
									</p>
								</React.Fragment>)
							}
							<p className="card-text"><em>
								Skráð {this.formatDate(item.skraningardagur)}
							</em></p>
							{/*<p><a className="text-light" href={'https://nyyrdi.arnastofnun.is/nyyrdi/'+item.id}>Sjá færslu í Nýyrðabanka</a></p>*/}
						</React.Fragment>
					}.bind(this))
				}
			</MalidCard>
		);
	}
}

export default NyyrdiView;



// WEBPACK FOOTER //
// ./src/components/NyyrdiView.js